export const SHOPIFY = '4d4b1c70-b157-11e9-8e3c-8d711a940c28';
export const CHECKBOOK = '8671c0a0-b943-11e9-bbb6-f5de100dd145'
export const SHIPPO = 'a981c800-cc22-11e9-82e9-97c0a39642af';
export const SENDGRID = 'ff15d270-d0e1-11e9-8ccc-651234d215f1';
export const SLACK = 'a05e0b10-d282-11e9-863c-eb6f5b7cfc38'
